// packages
import debounce from 'underscore/modules/debounce.js';

// local
import { trackEvent } from './helpers.js';

// default sizes for now
const width = 570;
const height = 570;

// all of the share buttons on a given page
const shareButtonEls = document.querySelectorAll('.share-button');

// set up each share button
shareButtonEls.forEach((el) => {
  // find its action...
  const action = el.getAttribute('data-action');
  // ...and preemptively determine if it's a popup or not...
  const shouldUsePopup = action === 'facebook' || action === 'twitter';
  // ...then finally get the <a> element itself
  const link = el instanceof HTMLAnchorElement ? el : el.querySelector('a');

  // react to clicks on the share button
  link.addEventListener('click', (event) => {
    // if it's twitter or facebook, we use a popup
    if (shouldUsePopup) {
      // don't let links be links
      event.preventDefault();

      // grab our URL
      const url = link.getAttribute('href');
      // determine the top edge of the popup
      const top = window.screenY + (window.outerHeight - height) / 2;
      // determine the left edge of the popup
      const left = window.screenX + (window.outerWidth - width) / 2;
      // pop it open with those parameters
      const popup = window.open(
        url,
        '_blank',
        `width=${width},height=${height},top=${top},left=${left}`
      );

      // if it succeeds, focus on it
      if (popup) {
        popup.focus();
        popup.opener = null;
      }
    }

    // See https://developers.google.com/analytics/devguides/collection/ga4/reference/events?sjid=8256709344012883295-NA&client_type=gtag#share
    trackEvent('share', {
      method: action,
      content_type: 'article',
      item_id: window.location.href,
    });
  });
});
